import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store';
import { Payer } from '../../models/payer.model';
import { Form, Row} from 'antd';
import { FormInputDate, FormSelect} from '../crmFormElement/FormInput';
import * as moment from 'moment';
import { GUTTOR_SPACE } from '../../constants/commonConstants';
import './tag.less';

const DownloadReportModal = ({form, setDownloadClaimsButtonEnabled, setSelectedPayers}: any): any => {
  const configuredPayers: any = useSelector((state: RootState): Payer[] => state.payerList.allPayers);
  const newConfiguredPayers = [{ id: 0, name: 'All Payers', value: 'All Payers', shortName: 'All Payers' }, ...configuredPayers];
  const payersList = newConfiguredPayers?.map((j: any): any => {
    return {'key': j.name, 'value': j.name, 'name': j.name}; }) || [];

  const todayDate = moment.default().startOf('day');
  const fifteenDaysBefore = moment.default(todayDate).subtract(14, 'days');

  const [toDate, setToDate] = useState(todayDate);
  const [dateFrom, setDateFrom] = useState();
  const [showDateRangeError, setShowDateRangeError] = useState(false);
  const onFilter = (inputValue: string, option: any): boolean => {
    return option.value.toUpperCase().includes(inputValue.toUpperCase());
  };

  const disabledToDate = (current: any): any => {
    const fromDate = form.getFieldValue('From');
    return fromDate ? todayDate.isBefore(moment.default(current), 'day') ||
    !current.isBetween(moment.default(fromDate), moment.default(fromDate).add(15, 'days'), 'day', '[)') :
    todayDate.isBefore(moment.default(current), 'day');
  };

  const onChangePayer = (): void => {
    setSelectedPayers([]);
    if (form?.getFieldsValue()['Payer/TPA']?.length > 1 && form?.getFieldsValue()['Payer/TPA']?.includes('All Payers')) {
      form?.setFieldsValue({ 'Payer/TPA': form?.getFieldsValue()['Payer/TPA']?.filter((ele: string): any => ele !== 'All Payers') });
    }
    const selectedPayer = [] as any;
    if (form.getFieldValue('Payer/TPA')?.length > 0 && !form?.getFieldsValue()['Payer/TPA']?.includes('All Payers')) {
      form.getFieldValue('Payer/TPA').forEach((payer: any): any => {
        selectedPayer.push((configuredPayers.find((item: any): any => {
          if (item.name === payer) {
            return item;
          }
        })));
      });
      const mappedSelectedPayers = selectedPayer?.map((payer: Payer): any => ({id: payer.id, shortName: payer.shortName,
        productCode : payer?.productCode})); // adding product code to acess claims for govt schemens
      setSelectedPayers(mappedSelectedPayers);
    }
    if (form?.getFieldsValue()['Payer/TPA']?.length) {
      setDownloadClaimsButtonEnabled(true);
    } else {
      setDownloadClaimsButtonEnabled(false);
    }
  };

  useEffect((): any => {
    const daysDifference = toDate?.diff(dateFrom, 'days');
    setShowDateRangeError(daysDifference > 15 ? true : false);
    if (form.getFieldValue('From') && form.getFieldValue('To') && toDate && daysDifference <= 15) {
      setDownloadClaimsButtonEnabled(true);
    } else {
      setDownloadClaimsButtonEnabled(false);
    }
  }, [dateFrom, toDate]);

  return (
    <Form form={form}>
      <React.Fragment>
        <Row gutter={GUTTOR_SPACE} className="download-claim-select-payer">
          <FormSelect
            detail={{
              form,
              key: 'Payer/TPA',
              placeholder: 'Select Payer/TPA',
              size: 24,
              options: (payersList || []),
              mode: 'multiple',
              selectType: 'category',
              filterOption: {onFilter},
              defaultValue: 'All Payers',
              allowClear: 'true',
              onChange: onChangePayer,
              maxTagCount: 2,
              dropDownRenderReq: false,
              isName: true,
              label: 'Payer/TPA',
              required: true,
            }}/>
        </Row>
        <Row gutter={GUTTOR_SPACE} className="download-claim-select-payer">
          <FormInputDate
            detail={{
              form,
              key: 'From',
              isName: true,
              label: 'From',
              size: 12,
              defaultValue: fifteenDaysBefore,
              onChange: (date: any, dateString: string): void => setDateFrom(date),
              required: true,
            }}/>
          <FormInputDate
            detail={{
              form,
              key: 'To',
              isName: true,
              label: 'To',
              size: 12,
              onChange: (date: any, dateString: string): void => setToDate(date),
              disabledDate: disabledToDate,
              defaultValue: todayDate,
              required: true,
              }}/>
        </Row>
        {
          showDateRangeError &&
          <Row>
            <p className="download-claim-modal-note">*The selected date range must be 15 days.</p>
          </Row>
        }
      </React.Fragment>
    </Form>
  );
};

export default withRouter(DownloadReportModal);
